<template>
  <v-card outlined flat>
    <v-card-text class="pa-4">
      <h3 class="primary--text mb-4">{{ $t('profile.devices.pass') }}</h3>
      <v-form ref="passwordForm" v-model="valid">
        <label>{{ $t('profile.devices.password') }}</label>
        <v-text-field
          v-model="form.oldPassword"
          :append-icon="form.oldPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
          :type="form.oldPasswordShow ? 'text' : 'password'"
          outlined
          dense
          single-line
          validate-on-blur
          :rules="passwordRules"
          @click:append="form.oldPasswordShow = !form.oldPasswordShow"
        ></v-text-field>
        <label>{{ $t('profile.devices.newPassword') }}</label>
        <v-text-field
          v-model="form.password"
          :append-icon="form.passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
          :type="form.passwordShow ? 'text' : 'password'"
          outlined
          dense
          single-line
          :rules="newPasswordRules"
          @click:append="form.passwordShow = !form.passwordShow"
        ></v-text-field>
        <CheckPasswordStrength v-if="form.password.length > 3" :value="form.password" />
        <label>{{ $t('profile.devices.repeatPassword') }}</label>
        <v-text-field
          v-model="form.confirmPassword"
          :append-icon="form.confirmPasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
          :type="form.confirmPasswordShow ? 'text' : 'password'"
          outlined
          dense
          single-line
          :rules="confirmPasswordRules"
          @click:append="form.confirmPasswordShow = !form.confirmPasswordShow"
        />
        <div class="d-flex mt-8">
          <v-btn outlined color="primary" :disabled="submitLoading" @click="generatePassword">
            {{ $t('resetPassword.generatePassword') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined class="mr-2" @click="clear" :disabled="submitLoading">
            {{ $t('profile.devices.clear') }}
          </v-btn>
          <v-btn color="primary" :disabled="submitLoading" :loading="submitLoading" @click="submitHandle" depressed>
            {{ $t('resetPassword.submit') }}
          </v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Service from '@/services'
import { generateString } from '@/utils/helpers'
import CheckPasswordStrength from '@/components/CheckPasswordStrength'

export default {
  name: 'ChangePasswordCard',
  components: {
    CheckPasswordStrength
  },
  data () {
    return {
      form: {
        oldPassword: '',
        oldPasswordShow: false,
        password: '',
        passwordShow: false,
        confirmPassword: '',
        confirmPasswordShow: false
      },
      submitLoading: false,
      valid: true,
      passwordRules: [
        (v) => !!v || this.$t('validation.passwordRequired')
      ],
      newPasswordRules: [
        (v) => !!v || this.$t('validation.passwordRequired'),
        (v) => v.length >= 8 || this.$t('validation.passwordInvalidLength')
      ],
      confirmPasswordRules: [
        (v) => !!v || this.$t('validation.confirmPasswordRequired'),
        (v) => v === this.form.password || this.$t('validation.passwordsMustMatch')
      ]
    }
  },
  methods: {
    generatePassword () {
      const newPassword = `${generateString()}${generateString()}`
      this.form.password = newPassword
      this.form.confirmPassword = newPassword
    },
    async submitHandle () {
      this.$refs.passwordForm.validate()
      if (!this.valid) return
      this.submitLoading = true
      try {
        await Service.put('/User/ChangePassword', {
          password: this.form.password,
          oldPassword: this.form.oldPassword
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('profile.devices.passChange'))
        this.clear()
      } catch (e) {}
      this.submitLoading = false
    },
    clear () {
      this.$refs.passwordForm.resetValidation()
      this.form = {
        oldPassword: '',
        oldPasswordShow: false,
        password: '',
        passwordShow: false,
        confirmPassword: '',
        confirmPasswordShow: false
      }
    }
  }
}
</script>
